'use strict';
var slider = {
    currentSlide: 0,
    totalSlides: 3,
    init: function() {
        var _this = this;
        var prevButton = document.querySelector('.features__prev');
        var nextButton = document.querySelector('.features__next');
        if (prevButton) {
            var handlePress = function() {
                prevButton.classList.add('features__prev--pressed');
            };
            var handleRelease = function() {
                prevButton.classList.remove('features__prev--pressed');
            };
            prevButton.addEventListener('mousedown', handlePress);
            prevButton.addEventListener('touchstart', handlePress);
            prevButton.addEventListener('mouseup', handleRelease);
            prevButton.addEventListener('touchend', handleRelease);
            prevButton.addEventListener('mouseleave', handleRelease);
            prevButton.addEventListener('click', function(e) {
                e.preventDefault();
                _this.prev();
            });
        }
        if (nextButton) {
            var handlePress1 = function() {
                nextButton.classList.add('features__next--pressed');
            };
            var handleRelease1 = function() {
                nextButton.classList.remove('features__next--pressed');
            };
            nextButton.addEventListener('mousedown', handlePress1);
            nextButton.addEventListener('touchstart', handlePress1);
            nextButton.addEventListener('mouseup', handleRelease1);
            nextButton.addEventListener('touchend', handleRelease1);
            nextButton.addEventListener('mouseleave', handleRelease1);
            nextButton.addEventListener('click', function(e) {
                e.preventDefault();
                _this.next();
            });
        }
        document.addEventListener('keydown', function(e) {
            if (e.key === 'ArrowLeft') _this.prev();
            if (e.key === 'ArrowRight') _this.next();
        });
        this.updateAll();
    },
    next: function() {
        if (this.currentSlide < this.totalSlides - 1) {
            this.currentSlide += 1;
            this.updateAll();
        }
    },
    prev: function() {
        if (this.currentSlide > 0) {
            this.currentSlide -= 1;
            this.updateAll();
        }
    },
    updateAll: function() {
        this.updateSlide();
        this.updatePagination();
        this.updateButtons();
    },
    updateSlide: function() {
        var _this = this;
        var slides = document.querySelectorAll('.features__slide');
        slides.forEach(function(slide, index) {
            if (index === _this.currentSlide) slide.classList.add('features__slide--active');
            else slide.classList.remove('features__slide--active');
        });
    },
    updatePagination: function() {
        var currentElement = document.querySelector('.features__current');
        var currentNumber = String(this.currentSlide + 1).padStart(2, '0');
        if (currentElement) currentElement.textContent = currentNumber;
    },
    updateButtons: function() {
        var prevButton = document.querySelector('.features__prev');
        var nextButton = document.querySelector('.features__next');
        if (prevButton) {
            if (this.currentSlide === 0) prevButton.classList.add('features__prev--disabled');
            else prevButton.classList.remove('features__prev--disabled');
        }
        if (nextButton) {
            if (this.currentSlide === this.totalSlides - 1) nextButton.classList.add('features__next--disabled');
            else nextButton.classList.remove('features__next--disabled');
        }
    }
};
slider.init();

//# sourceMappingURL=Kickstarter.69ffe082.js.map
